export default function (axios, api) {
  return {
    state: {
      news: [],
      article: {
        title: {
          rendered: false
        },
        thumbnail: '',
        date: null,
        content: null,
        content_alt: { content: null }
      }
    },

    getters: {
      news: state => state.news,
      article: state => state.article
    },

    actions: {
      getNews ({ commit }, { page, ids }) {
        commit('setNews', [])
        commit('setPagesTotal', 0)

        return api.fetchNews({ page, ids }).then(({ news, pages }) => {
          commit('setNews', news)
          commit('setPagesTotal', pages)
        })
      },

      getNCCampaignNews ({ commit, state }, ids) {
        commit('setNews', [])

        const fetchIds = typeof ids !== 'undefined' && ids.length > 0 ? ids : false

        return api.fetchNCCampaignNews(fetchIds, state.nationalCouncilCatId).then(news => {
          commit('setNews', news)
        })
      },

      getArticle ({ commit }, slug) {
        commit('clearHero')
        return api.fetchArticle(slug).then(post => {
          commit('setArticle', post)
          commit('setHero', post.thumbnail)
        })
      },

      getNCArticle ({ commit, state }, slug) {
        commit('setArticle', {
          title: {
            rendered: false
          },
          thumbnail: '',
          date: null,
          content: null
        })

        return api.fetchNCArticle(slug, state.nationalCouncilCatId).then(article => {
          commit('setArticle', article)
        })
      }
    },

    mutations: {
      setNews: (state, news)  => (state.news = news),
      setArticle: (state, article) => (state.article = article)
    }
  }
}
